
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="py-16 bg-[#003264]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Exalt Ventures Limited</h3>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              International Brand Franchise Operator
            </p>
            <p className="text-white/80 text-sm">
              Libya | Algeria | Malta
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-white/80 text-sm hover:text-white transition-colors whitespace-nowrap">
                Home
              </Link>
              <Link to="/about" className="text-white/80 text-sm hover:text-white transition-colors whitespace-nowrap">
                About Exalt
              </Link>
              <Link to="/brands" className="text-white/80 text-sm hover:text-white transition-colors whitespace-nowrap">
                Our Brands
              </Link>
              <Link to="/markets" className="text-white/80 text-sm hover:text-white transition-colors whitespace-nowrap">
                Markets
              </Link>
              <Link to="/digital" className="text-white/80 text-sm hover:text-white transition-colors whitespace-nowrap">
                Digital Presence
              </Link>
              <Link to="/contact" className="text-white/80 text-sm hover:text-white transition-colors whitespace-nowrap">
                Contact
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact Information</h3>
            <a 
              href="mailto:info@exaltvl.com" 
              className="text-white/80 text-sm hover:text-white transition-colors block mb-3"
            >
              info@exaltvl.com
            </a>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <p className="text-white/60 text-xs text-center">
            © {new Date().getFullYear()} Exalt Ventures Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
